import styled from 'styled-components';

export const ContainerPagination = styled.div`
  width: 100%;
  text-align: end;
  margin-top: 13px;
  display: flex;
`;

export const ContainerTotalItens = styled.div`
  margin: auto;
  margin-left: auto;
  margin-right: 18px;
  width: 131px;
`;

export const ContainerTable = styled.div`
  .ant-table-thead {
    th {
      padding: 10px;
      background-color: var(--primary-color-sefaz);
      font-weight: 500;
      color: var(--bottom-color-sefaz);
    }
  }
  .ant-table-row,
  ant-table-row-level-0 {
    td {
      padding: 11px 15px;
      max-width: 400px;
    }
    p {
      margin-bottom: 0;
    }
  }
`;
